import Globais from "../components/Globais/Globais";

// Converte de formato brasileiro (dd/mm/aaaa HH:MM) -> formato MySQL (aaaa-mm-dd HH:MM:SS)
function converterDataBrasileiraParaMySQL(dataBr) {
  if (!dataBr) return null;

  const [data, hora] = dataBr.split(" ");
  const [dia, mes, ano] = data.split("/");

  const horaFormatada = hora ? hora + ":00" : "00:00:00";

  return `${ano}-${mes}-${dia} ${horaFormatada}`;
}

// Converte de formato MySQL (aaaa-mm-dd HH:MM:SS) -> formato brasileiro (dd/mm/aaaa HH:MM)
function converterDataMySQLParaBrasileira(dataSql) {
  if (!dataSql) return null;

  const [data, hora] = dataSql.split(" ");
  const [ano, mes, dia] = data.split("-");

  const horaFormatada = hora ? hora.slice(0, 5) : "";

  return `${dia}/${mes}/${ano} ${horaFormatada}`;
}

// ✅ NOVO: Converte de formato brasileiro (dd/mm/aaaa) -> formato MySQL (aaaa-mm-dd)
function converterDataBrasileiraParaMySQLSomenteData(dataBr) {
  if (!dataBr) return null;

  const [dia, mes, ano] = dataBr.split("/");

  return `${ano}-${mes}-${dia}`;
}

// ✅ NOVO: Converte de formato MySQL (aaaa-mm-dd) -> formato brasileiro (dd/mm/aaaa)
function converterDataMySQLParaBrasileiraSomenteData(dataSql) {
  if (!dataSql) return null;

  const [ano, mes, dia] = dataSql.split("-");

  return `${dia}/${mes}/${ano}`;
}

// ✅ NOVO: Data/Hora atual no formato brasileiro (dd/mm/aaaa HH:MM)
function dataHoraAtualBrasileira() {
  const agora = new Date();
  const dia = String(agora.getDate()).padStart(2, "0");
  const mes = String(agora.getMonth() + 1).padStart(2, "0");
  const ano = agora.getFullYear();
  const horas = String(agora.getHours()).padStart(2, "0");
  const minutos = String(agora.getMinutes()).padStart(2, "0");

  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}

// ✅ NOVO: Data/Hora atual no formato MySQL (aaaa-mm-dd HH:MM:SS)
function dataHoraAtualMySQL() {
  const agora = new Date();
  const dia = String(agora.getDate()).padStart(2, "0");
  const mes = String(agora.getMonth() + 1).padStart(2, "0");
  const ano = agora.getFullYear();
  const horas = String(agora.getHours()).padStart(2, "0");
  const minutos = String(agora.getMinutes()).padStart(2, "0");
  const segundos = String(agora.getSeconds()).padStart(2, "0");

  return `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
}

function dataHoraFormatoMySQL(dataBr) {
  if (!dataBr) return null;

  const dia = String(dataBr.getDate()).padStart(2, "0");
  const mes = String(dataBr.getMonth() + 1).padStart(2, "0");
  const ano = dataBr.getFullYear();
  const horas = String(dataBr.getHours()).padStart(2, "0");
  const minutos = String(dataBr.getMinutes()).padStart(2, "0");
  const segundos = String(dataBr.getSeconds()).padStart(2, "0");

  return `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
}

// Função genérica para formatar datas
function formatarData(dataInput, formato = "dd/mm/aaaa") {
  if (!dataInput) return null;

  // console.log('Data input em formatarData: ', dataInput); 

  // Se a entrada for string, tenta criar objeto Date
  const data = new Date(dataInput);

  if (isNaN(data.getTime())) return null; // data inválida

  // console.log('new Date Data em formatarData: ', data);
  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();
  const horas = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");
  const segundos = String(data.getSeconds()).padStart(2, "0");

  // console.log('Data em formatarData: ', dia, mes, ano,horas, minutos, segundos);

  // Substitui tokens no formato
  return formato
    .replace("dd", dia)
    .replace("mm", mes)
    .replace("aaaa", ano)
    .replace("HH", horas)
    .replace("MM", minutos)
    .replace("SS", segundos);
}

// Função genérica para formatar datas 2
function formatarData2(dataStr, formato) {
  const [data, hora] = dataStr.split(' ');
  const [dia, mes, ano] = data.split('/');
  const [hh, mm, ss] = hora.split(':');

  const mapa = {
    'dd': dia,
    'mm': mes,
    'aaaa': ano,
    'aa': ano.slice(2),
    'hh': hh,
    'min': mm,
    'ss': ss
  };

  // Substitui os tokens do formato pela data correspondente
  return formato.replace(/(aaaa|aa|mm|dd|hh|min|ss)/g, token => mapa[token] || token);
}

// Função para formatar data no formato Brasileiro "dd/mm/aaaa hh:mm:ss"
// para o formato ISO "yyyy-mm-dd hh:mm:ss"
function dataBRParaDataIso(dataStr) {
  const [data, hora] = dataStr.split(' ');
  const [dia, mes, ano] = data.split('/');
  const [hh, mm, ss] = hora.split(':');
  let dataFormatada = ano + '-' + mes + '-' + dia + ' ' + hh + ':' + mm;

  if (ss === undefined) {
    dataFormatada += ':00';

  } else {
    dataFormatada += ':' + ss
  }
  return dataFormatada;
}

function getPeriodoAtualFormatado() {
  const diaInicialFixo = Globais.dia_periodo;
  const hoje = new Date();
  const anoAtual = hoje.getFullYear();
  const mesAtual = hoje.getMonth(); // 0 = Janeiro
  const diaHoje = hoje.getDate();

  // Ajusta o mês base dependendo do dia atual
  const mesBase = diaHoje < diaInicialFixo ? mesAtual - 1 : mesAtual;
  const anoBase = mesBase < 0 ? anoAtual - 1 : anoAtual;
  const mesCorrigido = (mesBase + 12) % 12;

  // Data inicial: dia fixo do mês base
  const inicio = new Date(anoBase, mesCorrigido, diaInicialFixo);

  // Data final: um dia antes do mesmo dia no mês seguinte
  const mesFinal = (mesCorrigido + 1) % 12;
  const anoFinal = mesFinal === 0 ? anoBase + 1 : anoBase;
  const fim = new Date(anoFinal, mesFinal, diaInicialFixo - 1);

  // Função auxiliar para formatar no padrão brasileiro
  const formatar = (data) => {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  return {
    dataInicio: converterDataBrasileiraParaMySQL(formatar(inicio) + " 00:00"),
    dataFim: converterDataBrasileiraParaMySQL(formatar(fim) + " 23:59"),
  };
}

function getPeriodoMensalFormatado() {
  const hoje = new Date();

  // Primeiro dia do mês
  const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

  // Último dia do mês
  const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

  // Função auxiliar para formatar no padrão brasileiro
  const formatar = (data) => {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  return {
    dataInicio: converterDataBrasileiraParaMySQL(formatar(inicio) + " 00:00"),
    dataFim: converterDataBrasileiraParaMySQL(formatar(fim) + " 23:59"),
  };
}

function estaDentroDoIntervalo(dataReferenciaStr, intervalo, unidade = 'M') {
  const agora = new Date();
  
  // Converte string "dd/mm/aaaa hh:mm:ss" para objeto Date
  const [data, hora] = dataReferenciaStr.split(' ');
  const [dia, mes, ano] = data.split('/');
  const [hh, mm, ss] = hora.split(':');
  // const dataReferencia = new Date(ano, mes - 1, dia, hh, mm, ss);
  const dataReferencia = new Date(ano, mes - 1, dia, hh, mm, ss);
  // console.log('dataReferencia: ', dataReferencia);

  // Calcula intervalo em milissegundos
  const fator = unidade === 'H' ? 60 * 60 * 1000 : 60 * 1000;
  const intervaloMs = intervalo * fator;

  // Define limites
  const inicio = dataReferencia;
  const fim = new Date(inicio.getTime() + intervaloMs);

  // console.log('Agora: ', agora);
  // console.log('Início: ', inicio);
  // console.log('Fim: ', fim);

  // Verifica se agora está dentro do intervalo
  return agora >= inicio && agora <= fim;
}

// Verifica se é uma data válida. Formato de entrada = "aaaa-mm-dd hh:mm:ss"
function validarData(data) {
  // Expressão regular para validar o formato aaaa-mm-dd hh:mm:ss
  const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

  if (!regex.test(data)) {
    return false; // formato inválido
  }

  // Quebra a string em partes
  const [dataStr, horaStr] = data.split(" ");
  const [ano, mes, dia] = dataStr.split("-").map(Number);
  const [hora, minuto, segundo] = horaStr.split(":").map(Number);

  // Cria objeto Date
  const date = new Date(ano, mes - 1, dia, hora, minuto, segundo);

  // Verifica se os valores batem (Date corrige automaticamente valores inválidos)
  return (
    date.getFullYear() === ano &&
    date.getMonth() === mes - 1 &&
    date.getDate() === dia &&
    date.getHours() === hora &&
    date.getMinutes() === minuto &&
    date.getSeconds() === segundo
  );
}

//Recebe um data dd/mm/aaaa hh:mm e retorna aaaammddhhmm
function codigoData(input) {
  // Divide data e hora
  const [data, hora] = input.trim().split(' ');

  // Divide dia, mês e ano
  const [dia, mes, ano] = data.split('/');

  // Divide hora e minuto
  const [horas, minutos] = hora.split(':');

  // Retorna no formato desejado
  return `${ano}${mes}${dia}${horas}${minutos}`;
}


function isDataMaior(data1, data2) {
  // Converte strings para objetos Date
  const d1 = new Date(data1);
  const d2 = new Date(data2);

  // Verifica se ambas são válidas
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    throw new Error("Uma ou ambas as datas são inválidas");
  }

  // Retorna true se data1 > data2
  return d1.getTime() > d2.getTime();
}

function isDataMenor(data1, data2) {
  // Converte strings para objetos Date
  const d1 = new Date(data1);
  const d2 = new Date(data2);

  // Verifica se ambas são válidas
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    throw new Error("Uma ou ambas as datas são inválidas");
  }

  // Retorna true se data1 > data2
  return d1.getTime() < d2.getTime();
}


// Exportando junto com as outras funções
export {
  converterDataBrasileiraParaMySQL,
  converterDataMySQLParaBrasileira,
  converterDataBrasileiraParaMySQLSomenteData,
  converterDataMySQLParaBrasileiraSomenteData,
  dataHoraAtualBrasileira,
  dataHoraAtualMySQL,
  dataHoraFormatoMySQL,
  formatarData,
  formatarData2,
  dataBRParaDataIso,
  getPeriodoAtualFormatado,
  getPeriodoMensalFormatado,
  estaDentroDoIntervalo,
  validarData,
  isDataMaior,
  isDataMenor,
  codigoData
};